/**
 * Matcher for "code" type.
 * @module
 */
var _ = require('optimizely-client-fn');
var Exec = require('core/exec');

exports.fieldsNeeded = [];

/**
 *
 * @param value
 * @param cond
 * @param {string|function} cond.value
 * @returns {boolean}
 */
exports.match = function(value, cond): boolean {
  if (_.isUndefined(cond.value)) {
    return true;
  } else if (typeof cond.value === 'function') {
    try {
      return Boolean(Exec.apply(cond.value));
    } catch(e) {
      return false;
    }
  } else {
    try {
      return Boolean(Exec.eval(cond.value));
    } catch(e) {
      return false;
    }
  }

  return false;
};
